import {
  ChangeDetectionStrategy,
  Component,
  inject,
  LOCALE_ID,
} from '@angular/core';
import { NzFooterComponent } from 'ng-zorro-antd/layout';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { NzOptionComponent, NzSelectComponent } from 'ng-zorro-antd/select';
import { DOCUMENT, UpperCasePipe } from '@angular/common';
import { ILocaleDTO } from '../../dto/config/locale.dto';
import { ConfigService } from '../../service/config.service';
import { AnalyticsService } from '../../service/analytics.service';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NzTagComponent } from 'ng-zorro-antd/tag';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-footer',
  imports: [
    NzFooterComponent,
    NzRowDirective,
    NzColDirective,
    NzSelectComponent,
    NzOptionComponent,
    UpperCasePipe,
    FormsModule,
    NzTagComponent,
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.less',
})
export class FooterComponent {
  private readonly router: Router = inject(Router);
  private readonly configService: ConfigService = inject(ConfigService);
  public readonly localeDTO: ILocaleDTO =
    this.configService.availableLocales.find(
      (localDTO: ILocaleDTO): boolean => inject(LOCALE_ID) === localDTO.value
    )!;
  private readonly analyticsService: AnalyticsService =
    inject(AnalyticsService);
  private readonly document: Document = inject<Document>(DOCUMENT);

  public getAvailableLocales(): ILocaleDTO[] {
    return this.configService.availableLocales;
  }

  public onLocaleSelectValueChanged(localeDTO: ILocaleDTO): void {
    if (this.document.defaultView) {
      this.analyticsService.event('locale_exec', {
        path: this.router.url,
        locale: localeDTO.value,
      });
      const localePath: string = localeDTO.baseHref;
      const routePath: string = this.router.url.substring(1);
      this.document.defaultView.location.assign(localePath + routePath);
    }
  }

  public getHref = (path: string): string =>
    this.configService.host + this.localeDTO.baseHref + path;
}
